import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/themes"

export const AdsContainer = styled("div")`
    background-color: #e5e5e5;
    width: 100%;
    margin-bottom: 1rem;

    @media (max-width: ${breakpoints.values.md - 1}px) {
        margin-bottom: 0;
    }
`
